// extracted by mini-css-extract-plugin
export default {"wrapper":"ID-z","addressLine":"JD-z","fullName":"KD-z"};